import * as React from 'react';
import { useState } from 'react';
import VoxelSwitch from '../../components/voxel/Forms/VoxelSwitch';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import SERPTrackingDialog from './components/SERPTrackingDialog';

export interface RankTrackingSwitchProps {
  project: ProjectGq;
  disabled?: boolean;
  reload: () => Promise<any>;
}

const RankTrackingSwitch: React.FC<RankTrackingSwitchProps> = ({ project, disabled, reload }) => {
  // Progress tracking - Switch on tracking
  const [trackingDialogOpen, setTrackingDialogOpen] = useState<boolean>(false);

  return (
    <div className={`flex flex-row items-center gap-6 `}>
      {/* Switch */}
      <VoxelSwitch
        title="Rank tracking"
        value={!!project.serpTrackingOn}
        onChange={() => setTrackingDialogOpen(true)}
        color="primary"
        disabled={disabled}
        size="md"
        onLabel='On'
        offLabel='Off'
      />
      <SERPTrackingDialog
        project={project}
        open={trackingDialogOpen}
        onClose={() => {
          setTrackingDialogOpen(false);
        }}
        reload={reload}
      />
    </div>
  );
};

export default RankTrackingSwitch;
